"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mod = void 0;
var mod = function (divisor, dividend) { return ((divisor % dividend) + dividend) % dividend; };
exports.mod = mod;
var sum = function (firstInput, secondInput) {
    var input1 = parseFloat(firstInput);
    var input2 = parseFloat(secondInput);
    if (!Number.isNaN(input1) && !Number.isNaN(input2)) {
        return (input1 + input2).toFixed(2);
    }
    if (!Number.isNaN(input1)) {
        return input1.toFixed(2);
    }
    if (!Number.isNaN(input2)) {
        return input2.toFixed(2);
    }
    return '0';
};
exports.default = sum;
